import { type FC } from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { LocationSelect } from "./LocationSelect";

interface Props {
    outletName: string;
    registers: Array<{
        id: string;
        name: string;
    }>;
    onBack: () => void;
    onRegisterSelect: (register?: string) => void;
    previous: string | null;
    presence: Array<string>;
}

export const LocationRegisterSelector: FC<Props> = ({
    outletName,
    registers,
    onBack,
    onRegisterSelect,
    previous,
    presence,
}) => {
    return (
        <div className="pt-8">
            <div
                onClick={() => onBack()}
                className="absolute top-4 text-gray-500 cursor-pointer hover:text-gray-400 dark:text-gray-200"
            >
                <FontAwesomeLight icon="long-arrow-left" />Back to outlet select
            </div>
            <p className="mb-2">Which register are you currently using at {outletName}?</p>
            <div>
                {registers.map(register => (
                    <LocationSelect
                        {...register}
                        onSelect={onRegisterSelect}
                        key={register.id}
                        icon="cash-register"
                        previous={register.id === previous}
                        presence={presence.includes(register.id)}
                    />
                ))}
                <LocationSelect id={undefined} name="Not using a register" onSelect={onRegisterSelect} icon="map-pin" />
            </div>
        </div>
    );
};
